module.exports = __webpack_public_path__ + "img/tapthe.8c48738e.jpg";